import { Box, CircularProgress, SxProps } from "@mui/material";
import useDelay from "decodable-ui/lib/hooks/useDelay";

export function LazyLoadingFallback({ sx }: { sx?: SxProps }) {
  const { delayPassed } = useDelay(1000);

  return (
    <Box
      sx={{
        height: "100%",
        display: "grid",
        placeItems: "center",
        color: "rgb(70% 70% 70%)",
      }}
    >
      {delayPassed ? <CircularProgress size={30} color="inherit" /> : null}
    </Box>
  );
}
